import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {BezoekschipOrganisation, IE3Party} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {ConsignmentUtils} from "../../../consignment.utils";

@Component({
    selector: 'app-consignment-organisation-party-details',
    templateUrl: './consignment-organisation-party-details.component.html',
    styleUrls: ['./consignment-organisation-party-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsignmentOrganisationPartyDetailsComponent {
  refData = PortvisitUtils;
  consignmentUtils = ConsignmentUtils;
  organisation: BezoekschipOrganisation;
  @Input() editMode: boolean;
  @Output() organisationChange: EventEmitter<BezoekschipOrganisation> = new EventEmitter<BezoekschipOrganisation>();

  protected party: IE3Party;

  @Input("organisation")
  set setOrganisation(organisation: BezoekschipOrganisation) {
    this.organisation = organisation;
    this.convertToParty();
  }

  private convertToParty() {
    if (!this.organisation) {
      this.party = null;
      return;
    }
    const streetWithNumber = this.splitStreetAndNumber(this.organisation.address);
    this.party = {
      name: this.organisation.fullName,
      identificationNumber: this.organisation.customsEORINumber,
      address: {
        street: streetWithNumber.street,
        number: streetWithNumber.number,
        postCode: this.organisation.zipCode,
        city: this.organisation.city,
        country: this.organisation.countryUnCode
      },
      communications: []
    }
  }

  private splitStreetAndNumber(streetWithNumber: string): StreetWithNumber {
    if (!streetWithNumber) {
      return { street: null, number: null };
    }
    const regex = /^(.*\D)\s*(\d+[A-Za-z-]*)$/;
    const match = streetWithNumber.match(regex);
    if (match) {
      return {
        street: match[1].trim(), // The street name
        number: match[2].trim()  // The street number with letters
      };
    }
    return {
      street: streetWithNumber,
      number: null
    }
  }

  onOrganisationChange(organisation: BezoekschipOrganisation) {
    if (!organisation) {
      organisation = {["isNewRecord"]: true} as any;
    }
    this.organisationChange.emit(organisation);
  }
}

interface StreetWithNumber {
  street: string;
  number: string;
}
